import React from 'react';
import PropTypes from 'prop-types';
import {Button, Clearfix, Panel} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import GreenLeafApi from '../utils/GreenLeafApi';
import ItemList from '../ItemList';
import {withRouter} from 'react-router';
import ErrorComponent from '../ErrorComponent';
import ProgressBarItem from '../teams/ProgressBar';

class ProgramsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      programs: [],
      error: null
    };

    this.deleteProgram = this.deleteProgram.bind(this);
    this.fetchPrograms = this.fetchPrograms.bind(this);
  }

  componentWillMount() {
    this.tableOptions = {
      tableHeaders: ['Name', 'Number of Teams', 'Overall Score'],
      tableData: ['name', 'size', 'score'],
      editItem: (program) => this.props.history.push(`/companies/${this.props.company_id}/programs/${program.id}/edit`),
      deleteItem: (program) => this.deleteProgram(program.id),
      goToItemDashboard: (program) => this.props.history.push(`/companies/${this.props.company_id}/programs/${program.id}`)
    };
  }

  async componentDidMount() {
    try {
      const scores = (await GreenLeafApi.Program.getOverallScore({company_id: this.props.company_id})).data.scores;

      const programs = this.props.programs.map(program => {
        let programScores = scores.find(s => s['program_id'] === program.id);

        let score = programScores ? <ProgressBarItem
          placement={'left'}
          score={programScores['program_score']}
          width={'200px'}/> : 'N/A';

        return {score, ...program};
      });

      for (let i = 0; i < programs.length; i++) {
        let teams = this.props.teams.filter(t => t.program_id === programs[i].id);
        programs[i].size = teams.length;
      }

      return this.setState({programs});
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  async fetchPrograms() {
    const scores = (await GreenLeafApi.Program.getOverallScore({company_id: this.props.company_id})).data.scores;
    let programs = (await GreenLeafApi.Program.get({companyId: this.props.company_id})).data;

    programs = programs.map(p => {
        let programScores = scores.find(s => s['program_id'] === p.id);

        let score = programScores ? <ProgressBarItem
            placement={'left'}
            score={programScores['program_score']}
            width={'200px'}/> : 'N/A';

        return {score, ...p};
    });

    for (let i = 0; i < programs.length; i++) {
      let teams = await GreenLeafApi.Team.get({ programId: programs[i].id });
      programs[i].size = teams.data.length;
    }

    this.setState({programs});
  }

  async deleteProgram(id) {
    try {
      await GreenLeafApi.Program.delete(id);
      await this.fetchPrograms();
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  render() {
    const error = this.state.error ? <ErrorComponent error={this.state.error}/> : '';

    return(
      <div>
        { error }
        <Panel>
          <Panel.Heading>
            <Panel.Title data-cy="programs-panel" componentClass="h3" className={'relative'}>
              <div className={'float-vertical-align pull-left'}>Programs</div>
              <div className={'pull-right'}>
                <Link className={'pull-right'} to={`/companies/${this.props.company_id}/programs/create`}>
                  <Button data-cy="create-program" className={'primary'}>Create</Button>
                </Link>
              </div>
              <Clearfix/>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body data-cy="programs-list">
            <ItemList
              options={this.tableOptions}
              items={this.state.programs}/>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

ProgramsPanel.propTypes = {
  programs: PropTypes.array,
  company_id: PropTypes.any.isRequired
};

export default withRouter(ProgramsPanel);


// WEBPACK FOOTER //
// ./src/components/program/ProgramsPanel.js